import React from "react";

import DictionaryEntry from "../atoms/dictionary-entry";

import "../../scss/organisms/_form.scss";

class FormContact extends React.Component {
  render() {
    const formContent = (
      <>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="first-name">
                {this.props.copy && this.props.copy.firstName ? (
                  this.props.copy.firstName
                ) : (
                  <DictionaryEntry
                    dictionaryEdges={this.props.dictionaryEdges}
                    dictionaryKey="contact.form.first-name"
                    language={this.props.language}
                  />
                )}
              </label>
              <input
                type="text"
                className="form-control"
                name="first-name"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="last-name">
                {this.props.copy && this.props.copy.lastName ? (
                  this.props.copy.lastName
                ) : (
                  <DictionaryEntry
                    dictionaryEdges={this.props.dictionaryEdges}
                    dictionaryKey="contact.form.last-name"
                    language={this.props.language}
                  />
                )}
              </label>
              <input
                type="text"
                className="form-control"
                name="last-name"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label htmlFor="email">
                {this.props.copy && this.props.copy.email ? (
                  this.props.copy.email
                ) : (
                  <DictionaryEntry
                    dictionaryEdges={this.props.dictionaryEdges}
                    dictionaryKey="contact.form.email"
                    language={this.props.language}
                  />
                )}
              </label>
              <input
                type="text"
                className="form-control"
                name="email"
                onChange={(e) => this.props.handleChange(e)}
                required="required"
              />
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message">
            {this.props.copy && this.props.copy.message ? (
              this.props.copy.message
            ) : (
              <DictionaryEntry
                dictionaryEdges={this.props.dictionaryEdges}
                dictionaryKey="contact.form.message"
                language={this.props.language}
              />
            )}
          </label>
          <textarea
            type="text"
            name="message"
            className="form-control"
            onChange={(e) => this.props.handleChange(e)}
            required="required"
          />
        </div>
        <div className="d-flex mt-6">
          <button className="ml-auto mr-auto btn btn-secondary">
            <span>
              {this.props.copy && this.props.copy.submit ? (
                this.props.copy.submit
              ) : (
                <DictionaryEntry
                  dictionaryEdges={this.props.dictionaryEdges}
                  dictionaryKey="contact.form.submit"
                  language={this.props.language}
                />
              )}
            </span>
          </button>
        </div>
        <div className="form-footer pt-5">
          <div className="row">
            <div className="col-md-6">
              <p>
                {this.props.copy && this.props.copy.disclaimer ? (
                  this.props.copy.disclaimer
                ) : (
                  <DictionaryEntry
                    dictionaryEdges={this.props.dictionaryEdges}
                    dictionaryKey="contact.form.disclaimer"
                    language={this.props.language}
                  />
                )}
              </p>
            </div>
          </div>
        </div>
      </>
    );

    const successMessage = (
      <p>
        {this.props.copy && this.props.copy.stateSuccess ? (
          this.props.copy.stateSuccess
        ) : (
          <DictionaryEntry
            dictionaryEdges={this.props.dictionaryEdges}
            dictionaryKey="contact.form.state-success"
            language={this.props.language}
          />
        )}
      </p>
    );
    const errorMessage = (
      <p>
        {this.props.copy && this.props.copy.stateError ? (
          this.props.copy.stateError
        ) : (
          <DictionaryEntry
            dictionaryEdges={this.props.dictionaryEdges}
            dictionaryKey="contact.form.state-error"
            language={this.props.language}
          />
        )}
      </p>
    );

    return (
      <section
        className={
          "form " +
          (this.props.className ? " " + this.props.className : "") +
          (this.props.inContainer ? " w-100" : "")
        }
      >
        <div className={!this.props.inContainer ? "container" : ""}>
          <form
            name="contact-form"
            method="post"
            data-netlify="true"
            onSubmit={(e) => this.props.submitForm(e)}
          >
            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
            <input type="hidden" name="form-name" value="contact-form" />
            <input type="hidden" name="path" value={this.props.path} />
            <h2 className="form-title">
              {this.props.copy && this.props.copy.title ? (
                this.props.copy.title
              ) : (
                <DictionaryEntry
                  dictionaryEdges={this.props.dictionaryEdges}
                  dictionaryKey="contact.form.title"
                  language={this.props.language}
                />
              )}
            </h2>
            {this.props.formState === undefined
              ? formContent
              : this.props.formState === "success"
              ? successMessage
              : errorMessage}
          </form>
        </div>
      </section>
    );
  }
}

export default FormContact;
